import { AccentColor } from "@/lib/colors";

const variantClasses: Record<AccentColor | "border", string> = {
  [AccentColor.Bubblegum]: "via-bubblegum",
  [AccentColor.Lavender]: "via-lavender",
  [AccentColor.Aegean]: "via-aegean",
  [AccentColor.Success]: "via-success",
  [AccentColor.Warning]: "via-warning",
  [AccentColor.Error]: "via-error",
  border: "via-border"
};

type GradientDividerVariant = AccentColor | "border";

type GradientDividerProps = {
  variant?: GradientDividerVariant;
};

export function GradientDivider({ variant = "border" }: GradientDividerProps) {
  return (
    <div
      className={`h-px bg-gradient-to-r from-transparent ${variantClasses[variant]} to-transparent max-w-[1840px] mx-auto`}
    />
  );
}
